import API from '../../../common/http/api.fetch';
import {success, responseMessage} from '../../../common/utils/util.notifier';
import {GRID_FETCH} from '../../../common/grid/grid.constants';
import I18N from '../../../common/utils/util.i18n';
import {IDS} from "./tasks-action-id.constants";
import {TYPES} from "./tasks-action-type.constants";
import {getDocFileNameFromPath} from "../../../common/utils/util.path";
import pick from 'lodash/pick';

export const fetchTasksGrid = (filter) => {
    return dispatch => {
        let assignee_uuid =  filter.assignee_uuid;
        if(!assignee_uuid && filter.my_tasks_only === 1)
            assignee_uuid =  filter.user_uuid;

        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: {
                ...filter,
                year_start: filter.year_start || new Date().getFullYear(),
                assignee_uuid,
                task_status: filter.task_status === 'isall' ? undefined : filter.task_status,
                scheme_code: filter.scheme_code || undefined,
                keyword:     filter.keyword     || undefined,
                identifier:     undefined,
                statePath:      undefined,
                isAdmin:        undefined,
                my_tasks_only:  filter.my_tasks_only,
                user_uuid:      undefined,
            },
        }).then(response => {
            if (response.data.path)
                return response.data;
            else
                dispatch({
                    type:   GRID_FETCH,
                    id:     IDS.accTasks,
                    path:   IDS.accTasksGrid,
                    ...response.data,
                    items: response.data.items.map(processTaskItem)
                })
        }, error => {
            responseMessage(error);
        })
    }
};

export const fetchTaskDetails = (uta_id, task_type = undefined) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/list-tasks',
            method: 'GET',
            params: { uta_id, task_type }
        }).then(response => {
            return processTaskItem(response.data.items[0]);
        })
    }
}

const processTaskItem = (item) => {
    const {uta_id, uta_type, doc_url, framework_code, assignee, description, status_code, status_name, username} = item;
    const requirements = JSON.parse(item.requirements) || [];
    const requiredRequirements = (uta_type === 'utrcer' && requirements.length) ? requirements.filter(req => req.required === 1) : [];

    return { ...item,
        id: uta_id,
        utaTypeName: I18N.translate(`ACCREDITATION.TASKS.TYPE.${uta_type.toUpperCase()}`),
        status_name: I18N.translate(`ACCREDITATION.TASKS.STATUS.${status_code.toUpperCase()}`, status_name),
        framework_code: framework_code?.toUpperCase(),
        assignee: `${assignee} (${username})`,
        assignee_name: assignee,
        descriptionColumn: description && (description.length < 64 ? description : `${description.slice(0, 64)}...`),
        requirements,
        requirementsColumn:
            uta_type === 'utrcer' ? (
                requiredRequirements.length > 2
                    ? requiredRequirements.map(req => req.name.split(' ')[0]).join(', ')
                    : requiredRequirements.map(req => req.name).join(', '))
            :
                requirements.length > 2
                    ? requirements.map(req => req.name.split(' ')[0]).join(', ')
                    : requirements.map(req => req.name).join(', '),
        filename: getDocFileNameFromPath(doc_url),
    }
}

export const submitEvidenceReviewOrDocRevision = (uta_id, review_requirements) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/submit-evidence-review-or-doc-revision',
            method: 'POST',
            data: {
                uta_id,
                review_requirements: review_requirements.map(item => pick(item,['ase_id','confirmed'])),
            }
        }).then(response => {
            // success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        }, error => {
            responseMessage(error)
        });
    }
}

export const submitImprovementActionStepForCompletion = (task_id, closing_comment) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/update-improvement-action-step`,
            method: 'POST',
            data: {
                task_id,
                status_code: 'sub', // submit for approval
                closing_comment,
            },
        }).then(response => {
            // success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        },error => {
            responseMessage(error)
        });
    };
};

export const fetchTasksGridSchemes = () => {
    return dispatch => {
        return API.fetch({
            url: '/rco/list-regulatory-schemes',
            method: 'GET',
            params: {
                for_assessment_only: 1,
                limit: -1,
                offset: 0,
            }
        }).then((response) => {
            dispatch({
                type: TYPES.FETCH_SCHEMES,
                id: IDS.accTasksGrid,
                items: [
                    {value: null, label: I18N.translate('COMMON.LABEL.ALL')},
                    ...response.data.map(item => ({
                        value: item.code,
                        label: item.name
                }))]
            })
        })
    }
}

export const localizeTasksGridFilter = (statuses, types) => {
    return dispatch => {
        dispatch({
            type: TYPES.LOCALIZE_TASKS_GRID_FILTER,
            id: IDS.accTasksGrid,
            taskStatuses: statuses.map(item => ({
                ...item,
                label:I18N.translate(`ACCREDITATION.TASKS.STATUS.${item.value.toUpperCase()}`)
            })),
            taskTypes: types.map(item => ({
                ...item,
                label:I18N.translate(`ACCREDITATION.TASKS.TYPE.${item.type.toUpperCase()}`)
            }))
        })
    }
}

// export const updateEvidenceRequirementConfirmation = (task, requirement, confirmed) => {
//     return dispatch => {
//         return API.fetch({
//             url: '/rco/update-evidence-requirement-confirmation',
//             method: 'PUT',
//             params: {
//                 task,
//                 requirement,
//                 confirmed,
//             }
//         }).then(response => {
//             success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
//         }, error => {
//             responseMessage(error)
//         });
//     }
// }